import { utils } from "./utils";

export interface BackOfficeHierarchySelection {
  bannerId?: number | null;
  storeId?: number | null;
  laneId?: number | null;
}

export interface NormalizeHierarchySelectionOptions {
  includeLane?: boolean;
}

export const hierarchyHelpers = {
  normalizeHierarchySelection(
    selection: BackOfficeHierarchySelection | null | undefined,
    options: NormalizeHierarchySelectionOptions = {},
  ): BackOfficeHierarchySelection {
    const includeLane = options.includeLane !== false;
    const bannerId = utils.toNullableNumber(selection?.bannerId);
    const storeId =
      this.hasHierarchyValue(bannerId)
        ? utils.toNullableNumber(selection?.storeId)
        : null;
    const laneId =
      includeLane && this.hasHierarchyValue(storeId)
        ? utils.toNullableNumber(selection?.laneId)
        : null;

    return { bannerId, storeId, laneId };
  },

  getHierarchyParams(selection: BackOfficeHierarchySelection = {}): any {
    const params: any = {};

    if (this.hasHierarchyValue(selection.bannerId)) {
      params.bannerId = String(selection.bannerId);
    }

    if (this.hasHierarchyValue(selection.storeId)) {
      params.storeId = String(selection.storeId);
    }

    if (this.hasHierarchyValue(selection.laneId)) {
      params.laneId = String(selection.laneId);
    }

    return params;
  },

  hasHierarchyValue(value: number | null | undefined): boolean {
    return !utils.isNil(value);
  },
};
